<template>
    <form @submit.prevent="sendMessageToClub">
      <label for="message">Your Message to the Club: </label>
      <textarea id="message" v-model="message" required></textarea>
      
      <button type="submit">Send Message</button>
      <p>{{ responseMessage }}</p>
    </form>
  </template>
  
  <script>
  import { ref } from 'vue';
  import { useStore } from 'vuex';
  
  export default {
    props: {
      purchaseId: {
        type: String,
        required: true
      }
    },
    setup(props) {
      const store = useStore();
      const message = ref('');
      const responseMessage = ref('');
  
      const sendMessageToClub = async () => {
        const userId = store.state.user.id;
        const response = await store.dispatch('clubs/sendMessageToClub', {
          userId,
          purchaseId: props.purchaseId,
          message: message.value
        });
        responseMessage.value = response.message;
      };
  
      return { message, sendMessageToClub, responseMessage };
    }
  }
  </script>

<style>
/* ==================== NATIVE APP STYLES ==================== */
body.is-native form {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px 16px calc(24px + env(safe-area-inset-bottom)) 16px;
  width: 100%;
  box-sizing: border-box;
  background: #fff;
}

body.is-native form label {
  font-size: 15px;
  font-weight: 600;
  color: #1f2937;
  display: block;
}

body.is-native form textarea {
  width: 100%;
  box-sizing: border-box;
  font-size: 16px !important;
  min-height: 140px;
  padding: 12px 14px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  background: #fff;
  -webkit-appearance: none;
  appearance: none;
  outline: none;
  resize: vertical;
  font-family: inherit;
}

body.is-native form textarea:focus {
  border-color: #dd4124;
}

body.is-native form button[type="submit"] {
  width: 100%;
  height: 48px;
  background: #dd4124;
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
}
</style>
